/**
 * @module cercaliagl/control/Control
 */
import { createUid } from '../util';
/**
 * @classdesc
 * Cercalia Control base class.
 * @api
 */
var Control = /** @class */ (function () {
    /**
     * @constructor
     * @param {Object} options Options
     */
    function Control(options) {
        /**
         * @private
         * @type {import("maplibre-gl").Map}
         */
        this.map_ = null;
        /**
         * @protected
         * @type {import('./ViewInterface').default}
         */
        this.viewInterface_ = null;
        /**
         * @protected
         * @type {string}
         */
        this.name_ = options.name !== undefined ? options.name : null;
        /**
         * @protected
         * @type {string}
         */
        this.className_ = options.className !== undefined ? options.className : 'cercalia.control.Control';
        /**
         * @protected
         * @type {string}
         */
        this.id_ = "".concat(this.className_, "_").concat(createUid());
        /**
         * @protected
         * @type {Element}
         */
        this.element_ = options.element;
        /**
         * @protected
         * @type {Element|null}
         */
        this.dialogElement_ = options.dialog !== undefined ? options.dialog : null;
    }
    Control.prototype.onAdd = function (map) {
        this.map_ = map;
        return this.element_;
    };
    /**
     * Get control id.
     * @api
     * @return {string} Id.
     */
    Control.prototype.getId = function () {
        return this.id_;
    };
    /**
     * Get class name.
     * @api
     * @return {string} Class name.
     */
    Control.prototype.getClass = function () {
        return this.className_;
    };
    /**
     * Get control name. Null if control has not defined name.
     * @api
     * @return {string|null} Class name.
     */
    Control.prototype.getName = function () {
        return this.name_;
    };
    /**
     * Get control HTML Element
     * @api
     * @return {Element} HTML Element
     */
    Control.prototype.getElement = function () {
        return this.element_;
    };
    /**
     * Returns `cercalia` Map object
     * @return {import('../Map').default} Cercalia map.
     * @api
     */
    Control.prototype.getCercaliaMap = function () {
        return this.map_.getCercaliaMap();
    };
    /**
     * Returns `mapboxgl` Map object
     * @return {import('maplibre-gl').Map}
     * @api
     */
    Control.prototype.getMap = function () {
        return this.map_;
    };
    /**
     * @param {import('./ViewInterface').default} viewInterface Interface control.
     */
    Control.prototype.setViewInterface = function (viewInterface) {
        this.viewInterface_ = viewInterface;
    };
    /**
     * @return {import('./ViewInterface').default} Interface
     */
    Control.prototype.getViewInterface = function () {
        return this.viewInterface_;
    };
    /**
     * Hide control.
     * @api
     */
    Control.prototype.hide = function () {
        // this.element_.hidden = true;
        this.element_.classList.add('hidden');
    };
    /**
     * Show control.
     * @api
     */
    Control.prototype.show = function () {
        // this.element_.hidden = false;
        this.element_.classList.remove('hidden');
    };
    /**
     * @param {Element|null} dialogElement Element
     */
    Control.prototype.setDialog = function (dialogElement) {
        this.dialogElement_ = dialogElement;
    };
    /**
     * @return {Element|null} DialogElement
     */
    Control.prototype.getDialog = function () {
        return this.dialogElement_;
    };
    return Control;
}());
export default Control;
//# sourceMappingURL=Control.js.map